export const UserBrandDetailsTabs = {
  CERTIFICATES: 'certificates'
}
